import React, { useState, useEffect } from 'react';
import { RadioGroup, Legend, RadioButton, Button, Card } from '@americanexpress/dls-react';
import { useParams } from 'react-router-dom';
import { Banner, Error, Loading  } from '../../components';
import { Expiration } from '../SaveAndRetrieve';

function UnSubscription() {
    const [data, setFormData] = useState(null);
    let { id } = useParams();
    const [showThankYou, setShowThakYouPage] = useState(false);
    const [prospData, setProspData] = useState(null);
    const [selection, setSelection] = useState(null);
    const [errorMessage, setErrorMessage] = useState(['Sorry, we encountered some issue while processing your request. Kindly try again.']);
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchProspDetail = async () => {
            const result = await fetch(`/api/Prospect/LeadEligibility/${id}`)
                .then(response => response.json())
                .then(json => json)
                .catch(err => { });

            setProspData(result);
            fetchData(result.selectedProduct);
        }
        fetchProspDetail();
    }, [id]);

    const fetchData = async (selectedProduct) => {
        const result = await fetch(`/api/Content/Journey/TwoStageForm/${selectedProduct}`)
            .then(response => response.json())
            .then(json => json)
            .catch(err => {

            });

        setFormData(result);
    };

    const clickHandler = async (e) => {
        e.preventDefault();
        setLoading(true);
        setShowError(false);
        if (selection === 'yes') {
            await fetch(`/api/UnsubscribeMail/UnSubscribe/${id}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            }).then(async response => {
                if (response.status === 200) {
                    setShowThakYouPage(true);
                }
                else {
                    setShowError(true);                   
                }
            });
        }
        if (selection === null) {
            setErrorMessage(['Please select any option! ']);
            setShowError(true);
        }
        else {
            setShowThakYouPage(true);
        };
        
        setLoading(false);
    }
    const changeValueHandler = (e) => {
        setSelection(e.target.value);
    }

    const selectPage = (data, prospData) => {
        if (prospData?.linkActiveIndicator === true) {
            if (data && showThankYou === false) {
                return (<><div className="text-align-center pad-4-tb">
                    <h1 className="text-uppercase">Welcome Back</h1>
                </div>
                    <div className="text-align-left pad-1-b">
                        Thank you for continuing your application for {data.journeyContent.productName}
                    </div>
                    <RadioGroup
                        onChange={changeValueHandler}
                        className="flex flex-align-items-start stack-1-r" >
                        <Legend> Would you like to unsubscribe from email reminders?</Legend>
                        <RadioButton id="Yes" name="Yes" label="Yes" value="yes" />
                        <RadioButton id="No" name="No" label="No" value="no" />
                    </RadioGroup>
                    <div className="flex flex-column flex-align-items-center pad-responsive">
                        <Button aria-label="Submit" type="submit" styleType="primary"
                            onClick={clickHandler}
                        >Continue</Button>
                    </div>
                </>)

            }
            else if (data && showThankYou === true && selection === 'no') {
                return (<>
                    <div className="text-align-center pad-4-tb">
                        <h1 className="text-uppercase">Thank You</h1>
                    </div>
                </>);
            }
            else if (data && showThankYou === true && selection === 'yes') {
                return (<>
                    <div className="text-align-center pad-4-tb">
                        <h1 className="text-uppercase">Thank You</h1>
                    </div>
                    <div className="text-align-center pad-1">
                        <strong>
                            You will no longer be receiving email reminders.
                        </strong>
                    </div>
                    <div className="col-md-12 text-align-center pad-1 nav-link">
                        <a className="nav-link" href="https://mediacampaigns.americanexpress.com/">
                            RETURN TO HOMEPAGE
                        </a>
                    </div>
                </>);
            }
        }

        else if (prospData?.linkActiveIndicator === false) {
            return <Expiration />
        }
    }

    return (
        <div className="dls-gray-01-bg">
            {loading && (
                <Loading showModal={true} />
            )}
            <div>
                <div className="row">
                    <div className="col-md-offset-1 col-md-10">
                        <div className="row margin-1-tb">
                            <Card className="col-md-3">
                                {data && (
                                    <>
                                        <Banner cardImage={data.journeyContent.cardArt} bannerTitle={data.journeyContent.bannerTitle}
                                            bannerUrl={data.journeyContent.bannerImageSrc} cardDisplayName={data.journeyContent.cardDisplayName}
                                            eligibilityCriteria={data.journeyContent.eligibilityCriteria} displayCityNames={data.displayCityNames}
                                        />
                                    </>
                                )}
                            </Card>
                            <Card className="col-md-9">
                                <div className="stack body">
                                    {showError && (
                                        <div className="stack-a">
                                            <Error errorList={errorMessage} />
                                        </div>
                                    )}
                                    <div className="pad-responsive">
                                        {data && (selectPage(data, prospData))}
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default UnSubscription;